import React, {Component} from 'react';
import './style/App.sass';
import i18n from "./i18n";
import MainPage from "./components/MainPage";
import {I18nextProvider} from "react-i18next";

class App extends Component{
    render(){
        return (
            <I18nextProvider i18n={i18n}>
                <div className="App">
                    <MainPage/>
                </div>
            </I18nextProvider>
        );
    }
}

export default App;
